module.exports = __webpack_public_path__ + "static/media/logo.1a3253d4.svg";